export type LogoProps = {};

export function Logo(props: LogoProps) {
  return (
    <img className="py-2" width={172} src="/PairTree_logo.svg" alt="PairTree" />
  );
}

export default Logo;
